import { render } from "./ocorrencias-list.vue?vue&type=template&id=d36fd068"
import script from "./ocorrencias-list.vue?vue&type=script&lang=js"
export * from "./ocorrencias-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__